"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createNewBundleExistingCustomerUrl = void 0;
var React = __importStar(require("react"));
var createNewBundleExistingCustomerUrl = function (_a) {
    var bundleType = _a.bundleType, addressId = _a.addressId, discountRecipeKey = _a.discountRecipeKey, discountCode = _a.discountCode;
    // which bundle type goes to which slug
    var slug = (function () {
        switch (bundleType) {
            case 'Diaper':
            case 'Training Pant':
                return 'diaper-bundler-2';
            case 'Fundamentals':
                return 'fundamentals-bundle';
            case 'Vitamin':
                return 'vitamin-bundle';
        }
    })();
    // add the query string
    var searchParams = new URLSearchParams();
    searchParams.set('ecnb', '1'); // ExistingCustomerNewBundle
    searchParams.set('aid', String(addressId)); // AddressId
    searchParams.set('source', 'nb'); // NewBundle
    searchParams.set('medium', 'acct'); // Account
    if (discountCode)
        searchParams.set('discount', discountCode); // DiscountCode
    if (discountRecipeKey)
        searchParams.set('drk', discountRecipeKey); // DiscountRecipeKey
    if (bundleType === 'Training Pant')
        searchParams.set('bt', 'tp'); // BundleType = TrainingPants
    return "/collections/".concat(slug, "?").concat(searchParams.toString());
};
exports.createNewBundleExistingCustomerUrl = createNewBundleExistingCustomerUrl;
exports.default = (function (_a) {
    var _b, _c, _d, _e;
    var addressId = _a.addressId, discountCode = _a.discountCode;
    // these 2 bundles are not yet launched in canada. we'll hardcode hide
    // them because ethan doesn't feel like making CMS settings
    var shouldShowVitaminsBlock = !/hellobello\.ca/.test(window.location.href);
    var shouldShowFundamentalsBlock = shouldShowVitaminsBlock;
    var renderBlock = function (_a) {
        var bundleType = _a.bundleType, text = _a.text, imageUrl = _a.imageUrl;
        return (React.createElement("a", { className: 'text-white font-bold flex-container align-middle align-center', href: (0, exports.createNewBundleExistingCustomerUrl)({ bundleType: bundleType, addressId: addressId, discountCode: discountCode }), style: { height: 118, borderRadius: 8, background: "url(".concat(imageUrl, ")"), backgroundSize: 'cover', paddingBottom: 60, backgroundPosition: 'center' } }, text));
    };
    return (React.createElement("div", { className: 'add-bundles margin-top-4', style: { margin: '0 0.625em' } },
        React.createElement("div", { className: 'font-bold margin-bottom-2' }, "Add new bundles"),
        React.createElement("div", { className: 'add-bundle-blocks', style: { display: 'grid', gap: 10 } },
            renderBlock({ bundleType: 'Diaper', text: 'Diapers', imageUrl: (_b = window.accountApp.addNewBundleImages) === null || _b === void 0 ? void 0 : _b.diapers }),
            renderBlock({ bundleType: 'Training Pant', text: 'Training Pants', imageUrl: (_c = window.accountApp.addNewBundleImages) === null || _c === void 0 ? void 0 : _c.trainingPants }),
            shouldShowFundamentalsBlock && renderBlock({ bundleType: 'Fundamentals', text: 'Fundamentals', imageUrl: (_d = window.accountApp.addNewBundleImages) === null || _d === void 0 ? void 0 : _d.fundamentals }),
            shouldShowVitaminsBlock && renderBlock({ bundleType: 'Vitamin', text: 'Vitamins', imageUrl: (_e = window.accountApp.addNewBundleImages) === null || _e === void 0 ? void 0 : _e.vitamins }))));
});
